module.exports = __webpack_public_path__ + "ef14b98fa3bce04cd09fcc8dab5056ec.pdf";